import { type ProductOption } from "@kanpla/api-contract";

import { applyDiscount } from "~/utils/apply-discount";
import { roundAwayFromZero } from "~/utils/round-away-from-zero";

import { type KioskDisplayVariant } from "./types";

type ParseDisplayVariantArgs = {
  option: ProductOption;
  discountPercentage: number | null;
  showPricesInclVat: boolean;
};

export function parseDisplayVariant({
  option,
  discountPercentage,
  showPricesInclVat
}: ParseDisplayVariantArgs): KioskDisplayVariant {
  return {
    id: option.id,
    name: option.name,
    minimum: option.minimum,
    maximum: option.maximum,
    choices: option.choices.map((choice) => {
      let unitDisplayPrice: number | null = null;
      if (choice?.unitPriceInclVat) {
        unitDisplayPrice = showPricesInclVat
          ? choice.unitPriceInclVat
          : roundAwayFromZero(choice.unitPriceExclVat);
        if (discountPercentage) {
          unitDisplayPrice = roundAwayFromZero(
            applyDiscount(unitDisplayPrice, "percentage", discountPercentage)
          );
        }
      }

      return {
        id: choice.id,
        name: choice.name,
        unitDisplayPrice,
        maximum: choice.maximum ?? null,
        allergens: choice.allergens ?? []
      };
    })
  };
}
